// CrearOrdenCompraDialog.jsx
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  IconButton,
  Divider,
  Stack,
  Autocomplete,
  Grid,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { StyledCellHeader } from '../../../../components/StyledCellHeader';
import { Add, ArrowBack, Print, RemoveCircleOutline } from '@mui/icons-material';
import AutocompleteWithAdd from '../../../../components/AutocompleteWithAdd';
import ProductsForm from '../../productos/productsform';
import { fetchProveedores, fetchProductosPorCategoria, fetchAlmacenes  } from '../../../../utils/generalsFetch';
import CrearProveedorDialog from '../proveedores/crearproveedordialog';
import Selector from '../../../../components/Selector';
import { useNavigate } from 'react-router-dom';
import AppTheme from '../../../../shared-theme/AppTheme';
import { alpha } from '@mui/material/styles';
import Header from '../../../../components/Header';
import SideMenu from '../../../../components/SideMenu';
import AppNavbar from '../../../../components/AppNavbar';
import { CssBaseline } from '@mui/material';
import { useParams } from 'react-router-dom';
import { chartsCustomizations, dataGridCustomizations, datePickersCustomizations, treeViewCustomizations } from '../../../dashboard/theme/customizations';
import { PlantillaOrdenCompra } from './plantillas/plantillaordencompra';

const xThemeComponents = {
    ...chartsCustomizations,
    ...dataGridCustomizations,
    ...datePickersCustomizations,
    ...treeViewCustomizations,
  };


const OrdenCompraDetail = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [openCrearProveedor, setOpenCrearProveedor] = useState(false)
  const [numeroOrden, setNumeroOrden] = useState('');
  const [proveedor, setProveedor] = useState({});
  const [proveedores, setProveedores] = useState([]);
  const [productos, setProductos] = useState([]);
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [inputValueProducto, setInputValueProducto] = useState('');
  const [openCrearProducto, setOpenCrearProducto] = useState(false);
  const [fechaEmision, setFechaEmision] = useState(new Date());
  const [fechaEntrega, setFechaEntrega] = useState(new Date());
  const [terminosCondiciones, setTerminosCondiciones] = useState('');
  const [subtotal, setSubtotal] = useState(0);
  const [impuestos, setImpuestos] = useState(0);
  const [total, setTotal] = useState(0);
  const [observaciones, setObservaciones] = useState('');
  const [estado, setEstado] = useState('abierta');
  const [almacenes, setAlmacenes] = useState([]);
  const [almacenSeleccionado, setAlmacenSeleccionado] = useState(null);
  const [errorAlmacen, setErrorAlmacen] = useState('');
  const [errorProveedor, setErrorProveedor] = useState('');
  const [errorProductos, setErrorProductos] = useState('');
  const [errorFechaEmision, setErrorFechaEmision] = useState('');
  const [errorFechaEntrega, setErrorFechaEntrega] = useState('');
  const [errorGeneral, setErrorGeneral] = useState('');
  const [ordenCompra, setOrdenCompra] = useState(null);

  React.useEffect(() => {
    fetchProveedores({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setProveedores(data);
      getOrdenCompra(data);
    });
    fetchProductosPorCategoria({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany'), tipocategoria: "generico" }).then((data) => {
      setProductos(data);
    });
    fetchAlmacenes({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setAlmacenes(data);
    });
    

    
  }, []); 

  React.useEffect(() => {
    handleCalcularTotales();
  }, [productosSeleccionados]);

  async function getOrdenCompra(proveedores){
    const response = await fetch(process.env.REACT_APP_SERVER_URL+`/api/ordenes-compra/detalle/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany'),
      },
    });
    const data = await response.json();
    setProveedor(proveedores.find(proveedor => proveedor.value === data.orden.id_proveedor));
    setAlmacenSeleccionado(data.orden.id_almacen);
    setNumeroOrden(data.orden.numero_orden);
    setFechaEmision(data.orden.fecha_emision);    
    setFechaEntrega(data.orden.fecha_entrega);
    setTerminosCondiciones(data.orden.terminos_condiciones);
    setProductosSeleccionados(data.detalles);
//    setSubtotal(data.orden.subtotal);
  }

  const handleAdd = (newValue) => {
    setOpenCrearProveedor(true)
    const newOption = { label: newValue };
    setProveedores((prev) => [...prev, newOption]);
  };

  const handleCrearProducto = () => {
    setOpenCrearProducto(false)
    fetchProductosPorCategoria({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany'), tipocategoria: "generico" }).then((data) => {
      setProductos(data);
      
    });
  }

  const handleCalcularTotales = () => {
    setSubtotal(productosSeleccionados.reduce((acc, producto) => acc + parseFloat(producto.subtotal), 0));
    setImpuestos(productosSeleccionados.reduce((acc, producto) => acc + parseFloat(producto.impuestos), 0));
    setTotal(productosSeleccionados.reduce((acc, producto) => acc + parseFloat(producto.subtotal) + parseFloat(producto.impuestos), 0));
  }

  const validateFields = () => {
    let valid = true;
    setErrorProveedor('');
    setErrorProductos('');
    setErrorFechaEmision('');
    setErrorFechaEntrega('');
    setErrorGeneral('');

    if (!proveedor || !proveedor.value) {
      setErrorProveedor('Seleccione un proveedor.');
      valid = false;
    }
    if (!almacenSeleccionado) {
      setErrorAlmacen('Seleccione un almacen.');
      valid = false;
    }
    if (!productosSeleccionados || productosSeleccionados.length === 0) {
      setErrorProductos('Agregue al menos un producto.');
      valid = false;
    }
    if (!fechaEmision) {
      setErrorFechaEmision('Ingrese la fecha de emisión.');
      valid = false;
    }
    if (!fechaEntrega) {
      setErrorFechaEntrega('Ingrese la fecha de entrega.');
      valid = false;
    }
    return valid;
  };

  const handleGuardarOrden = async () => {
    
    if (!validateFields()) {
      setErrorGeneral('Por favor corrija los errores antes de guardar.');
      return;
    }
      const response = await fetch(process.env.REACT_APP_SERVER_URL+'/api/ordenes-compra/'+id, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': "13783dd0-e4d3-4b8d-9b3b-c087b9afa1a3",
      },
      body: JSON.stringify({
        id_proveedor: proveedor.value,
        detalles: productosSeleccionados,
        fecha_emision: fechaEmision,
        fecha_entrega: fechaEntrega,
        observaciones: observaciones,
        total_estimado: total,
        estado: estado,
        idcompany: "8c86f63d-2599-4267-8adb-4a08ca6de13f",
        usuario_creador: "13783dd0-e4d3-4b8d-9b3b-c087b9afa1a3",
        id_almacen: almacenSeleccionado
      }),
    });
    if (response.ok) {
      onClose();
    }
    else{
      alert(response.statusText)
    }
  }
  function onClose(){
    navigate(-1);
  }

  const handleAddProveedor = () => {
    setOpenCrearProveedor(false)
    fetchProveedores({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setProveedores(data);
    });
  }

  const handleImprimir = () => {
    PlantillaOrdenCompra(
      proveedor,
      fechaEmision,
      fechaEntrega,
      numeroOrden,
      "localStorage.getItem('nombrecompania')",
      "localStorage.getItem('direccion')",
      "localStorage.getItem('telefono')",
      productosSeleccionados
   )
  }

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: 'flex' }}>
            <SideMenu />
            <AppNavbar />
            {/* Main content */}
            <Box
            component="main"
            sx={(theme) => ({
                flexGrow: 1,
                backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
                overflow: 'auto',
            })}>
            <Stack
                spacing={2}
                sx={{
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
                }}>
                <Header parent={"Logistica y Almacenes"} child={"Orden de Compra"}/>
                <br></br>
                {openCrearProducto && <ProductsForm  onClose={()=>{handleCrearProducto()}} />}
                <CrearProveedorDialog open={openCrearProveedor}  onClose={()=>{handleAddProveedor()}} />
                {!openCrearProducto && (
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Box>
                    <Button variant="outlined" color="primarybutton" sx={{ mr: 2, fontWeight: "bold" }} startIcon={<ArrowBack/>} onClick={onClose}>
                      Atras
                    </Button>
                  </Box>
                  <Box>
                  <Button variant="outlined" color="primarybutton" sx={{ mr: 2, fontWeight: "bold" }} startIcon={<Print/>} onClick={()=>{handleImprimir()}}>
                      Imprimir
                    </Button>
                    <Button variant="outlined" color="error" sx={{ fontWeight: "bold" , borderColor:"error.main", color:"error.main"}} startIcon={<RemoveCircleOutline/>}>
                      Eliminar Orden
                    </Button>

                  </Box>
                </Box>
                )}
                {!openCrearProducto && (
                    <Box boxShadow={1} px={5} py={5} >

                    <Box display="flex" justifyContent="space-between" alignItems="center" >
                        <Typography variant="h6" fontWeight={700}>Editar Orden de Compra</Typography>
                    </Box>
                    
                    <Box dividers>
                        <Box mb={2}>
                        <Stack spacing={2} mt={1}>
                            <AutocompleteWithAdd
                            disabled={true}
                            label="Proveedor"
                            options={proveedores}
                            value={proveedor}
                            onChange={(val) => setProveedor(val)}
                            onAdd={handleAdd}
                            error={!!errorProveedor}
                            />
                            {errorProveedor && <Typography color="error" fontSize={13} textAlign={"left"}>{errorProveedor}</Typography>}
                            <Selector disabled={true} placeholder="Selecciona un almacen" options={almacenes} value={almacenSeleccionado} onChange={((e) => setAlmacenSeleccionado(e.target.value))}/>
                            {errorAlmacen && <Typography color="error" fontSize={13} textAlign={"left"}>{errorAlmacen}</Typography>}
                            <Grid container spacing={2}>
                            <Grid item size={6}>
                                <Typography fontSize={12} fontWeight={600} textAlign={"left"}>Fecha de Emisión</Typography>
                                <TextField disabled={true} placeholder="Fecha de Emisión" fullWidth type='date' value={fechaEmision} onChange={(e) => {setFechaEmision(e.target.value)}} error={!!errorFechaEmision}/>
                                {errorFechaEmision && <Typography color="error" fontSize={13} textAlign={"left"}>{errorFechaEmision}</Typography>}
                            </Grid>
                            <Grid item size={6}>
                                <Typography fontSize={12} fontWeight={600} textAlign={"left"}>Fecha de Entrega</Typography>
                                <TextField disabled={true} placeholder="Fecha de Entrega" fullWidth type='date' value={fechaEntrega} onChange={(e) => setFechaEntrega(e.target.value)} error={!!errorFechaEntrega}/>
                                {errorFechaEntrega && <Typography color="error" fontSize={13} textAlign={"left"}>{errorFechaEntrega}</Typography>}
                            </Grid>
                            </Grid>
                            
                            <TextField placeholder="Términos y Condiciones (Opcional)" fullWidth value={terminosCondiciones} onChange={(e) => setTerminosCondiciones(e.target.value)}/>
                        </Stack>
                        </Box>

                        <Divider sx={{ my: 2, mt: 5 }} />
                        <Autocomplete
                        options={productos}
                        value={selectedProduct}
                        inputValue={inputValueProducto}
                        onInputChange={(event, newInputValue) => setInputValueProducto(newInputValue)}
                        onChange={(event, value) => {
                            if (value) {
                            console.log(value)
                            setProductosSeleccionados(prev => [...prev, {...value, cantidad:1, impuestos:0, subtotal:value.precio}]);
                            setSelectedProduct(null); 
                            setInputValueProducto('');
                            }
                        }}
                        getOptionLabel={(option) => option.nombre}
                        renderInput={(params) => <TextField {...params} placeholder="Buscar Producto" />}
                        />
                        {errorProductos && <Typography color="error" fontSize={13} textAlign={"left"} sx={{mt:1,mb:1}}>{errorProductos}</Typography>}
                        <br></br>

                        <Table size="small">
                        <TableHead>
                            <TableRow>
                            <StyledCellHeader>Producto</StyledCellHeader>
                            <StyledCellHeader>Cantidad</StyledCellHeader>
                            <StyledCellHeader>Precio Unitario</StyledCellHeader>
                            <StyledCellHeader>Impuestos</StyledCellHeader>
                            <StyledCellHeader>Subtotal</StyledCellHeader>
                            <StyledCellHeader align="right"></StyledCellHeader>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {productosSeleccionados.map((producto, idx) => (
                            <TableRow key={producto.id || idx}>
                                <TableCell>{producto.nombre === '' ? producto.id : producto.nombre}</TableCell>
                                <TableCell>
                                <TextField
                                    type="number"
                                    value={producto.cantidad}
                                    onChange={(e) => {
                                    setProductosSeleccionados(prev =>
                                        prev.map((p, i) =>
                                        i === idx ? { ...p, cantidad: e.target.value, subtotal: e.target.value * p.precio } : p
                                        )
                                    );
                                    }}
                                />
                                </TableCell>
                                <TableCell>
                                <TextField
                                    type="number"
                                    value={producto.precio}
                                    onChange={(e) => {
                                    setProductosSeleccionados(prev =>
                                        prev.map((p, i) =>
                                        i === idx ? { ...p, precio: e.target.value, subtotal: e.target.value * p.cantidad } : p
                                        )
                                    );
                                    }}
                                />
                                </TableCell>
                                <TableCell>
                                <TextField
                                    type="number"
                                    value={producto.impuestos}
                                    onChange={(e) => {
                                    setProductosSeleccionados(prev =>
                                        prev.map((p, i) =>
                                        i === idx ? { ...p, impuestos: e.target.value } : p
                                        )
                                    );
                                    }}
                                />
                                </TableCell>
                                <TableCell>
                                <TextField type="number" value={producto.subtotal} disabled />
                                </TableCell>
                                <TableCell align="right">
                                <IconButton color="error" size="small" onClick={() => {
                                    setProductosSeleccionados(prev => prev.filter((_, i) => i !== idx));
                                }}>
                                    <RemoveCircleOutline fontSize="small" color="error" />
                                </IconButton>
                                </TableCell>
                            </TableRow>
                            ))}
                        </TableBody>
                        </Table>

                        <Box mt={2} display={"flex"}>
                        <Button sx={{borderColor:"primary.main",color:"primary.main"}} startIcon={<Add sx={{color:"primary.main"}}/>} variant="outlined" onClick={()=>{setOpenCrearProducto(true)}}> Crear Producto</Button>
                        </Box>

                        <Divider sx={{ my: 2 }} />

                        <Typography variant="subtitle1" fontWeight={600} textAlign={"left"}>Totales</Typography>
                        <Box display="flex" flexDirection="column" gap={1} mt={1}>
                        <Box display="flex" justifyContent="space-between">
                            <Typography>Subtotal</Typography>
                            <Typography>${subtotal}</Typography>
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                            <Typography>Impuestos</Typography>
                            <Typography>${impuestos}</Typography>
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                            <Typography>Total</Typography>
                            <Typography>${total}</Typography>
                        </Box>
                        </Box>
                    </Box>

                    <Box display={"flex"} justifyContent={"flex-end"} marginTop={5}>
                        <Button  variant="outlined" sx={{marginRight:5}} onClick={onClose}>Cancelar</Button>
                        <Button color='primarybutton' sx={{fontWeight:"bold"}} onClick={handleGuardarOrden} variant="contained">Guardar Orden</Button>
                    </Box>
                    </Box>
                )}
            </Stack>
            </Box>
        </Box>
    </AppTheme>
  );
};

export default OrdenCompraDetail;
